import { render, staticRenderFns } from "./PaymentPendingView.vue?vue&type=template&id=d3e7e488"
import script from "./PaymentPendingView.vue?vue&type=script&lang=ts"
export * from "./PaymentPendingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports